export const DOWNLOAD_RECEIPT_EMAIL = `
query($billNumber: String!){
   getBillFile(billNumber:$billNumber){
      billNumber,
      cardReceiptFileUrl,
      billReceiptFileUrl,
   }
}
`;
